module.exports = __webpack_public_path__ + "media/background.ed182103.mp4";